import React from "react";
import { fetchSocialMediaSubmissions, fetchSocialWinners } from "../../../actions/socialMediaSubmission";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AvatarEditor from "react-avatar-editor";
import history from "../../../history.js";
import moment from "moment";
import { Loader } from "../../../components/loader";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import "react-select/dist/react-select.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter, selectFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { BreadCrumb } from "../../../components/breadcrumb";
import Responsive from "react-responsive";
import config from "../../../config";
import _ from "lodash";
import Store from "../../../store";

const $ = window.$;
const { SearchBar } = Search;

const SOCIALMEDIA = {
  instagram : "instagram",
  facebook : "facebook",
};


const orientation = window.matchMedia("(max-width: 700px)").matches ? "vertical" : "horizontal";

class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    socialMediaSubmissions: [],
    isLoading : true,
    selectedTab: "Mediafiles",
    isLoadingMediaWinners: false,
    socialMediaWinners: [],
  };

  tableHeaderColumnData = [
    {
      dataField: "name",
      text: "Pet Name",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "social_media_type",
      text: "Social Media Type",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "social_media_profile",
      text: "Social Media Profile",
      sort: true,
      formatter: (cell, row) =>{
        return (
         <span className="m-topbar__userpic">       
          <span className="mx-auto my-0 px-2">
          <strong>
            { row.social_media_type == SOCIALMEDIA.instagram ?
            <a
              href={ `https://www.instagram.com/${cell}`}
              target="_blank"               
             >
             {cell} 
            </a>:        
              row.social_media_type == SOCIALMEDIA.facebook ?       
             <a
            href={ `https://www.facebook.com/${cell}`}
            target="_blank"               
            >
            {cell} 
            </a>:null    
            }
          </strong>
          </span> 
         </span>
        )
      }
    },
    {
      dataField: "category",
      text: "Category",
      sort: true,
      formatter: (cell, row) => (
        <div>
          { row.category ?  row.category : ''}       
        </div>
      )
    },
    {
      dataField: "createdAt",
      text: "Submitted At",
      sort: true,
      formatter: (cell) => (
        <div>
          {moment(cell).format("lll")}<br/>
          <i className="social-text-sm">({moment(cell).startOf('second').fromNow()})</i>
        </div>
      )
    },
    {
      dataField: "SocialMediaFiles",
      text: "Files",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div>
            <ul>
              {row.SocialMediaFiles.map((file, index) => {
                return (
                  <li style={{ listStyleType: "none" }} key={index}>
                    <a href={process.env.REACT_APP_S3_BASE + "/" + file.bucket + "/" + file.filepath} target="_blank">
                      {file.filename}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      },
    },
  ];

  tableHeaderSocialMediaWinners = [
    {
      dataField: "full_name",
      text: "Name",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "contact_number",
      text: "Phone",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "address",
      text: "Address",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "city",
      text: "City",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "state",
      text: "State",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "zip_code",
      text: "Zip Code",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "country",
      text: "Country",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "selected_gift_name",
      text: "Gift",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "createdAt",
      text: "Submitted At",
      sort: true,
      formatter: (cell) => (
        <div>
          {moment(cell).format("lll")}<br/>
          <i className="social-text-sm">({moment(cell).startOf('second').fromNow()})</i>
        </div>
      )
    },   
  ];

  changeTab = (tabName) => {
    this.setState({ selectedTab:tabName }); 
  }  

  changeCustomTimeTab = (tabName) => {  
    this.setState({ selectedTab:tabName, isLoadingMediaWinners : true }); 
    this.props.fetchSocialWinners();
  }

  componentDidMount() {
    this.props.fetchSocialMediaSubmissions();
  }

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.data.socialMediaSubmissionsReducer.socialMediaSubmissions !==
      this.props.data.socialMediaSubmissionsReducer.socialMediaSubmissions
    ) {
      let socialMediaSubmissions = nextProps.data.socialMediaSubmissionsReducer.socialMediaSubmissions;

      this.setState({
        socialMediaSubmissions: socialMediaSubmissions,
        isLoading: false,
      });
    }

    if (
      nextProps.data.socialMediaSubmissionsReducer.socialMediaWinners !==
      this.props.data.socialMediaSubmissionsReducer.socialMediaWinners
    ) {
      let socialMediaWinners= nextProps.data.socialMediaSubmissionsReducer.socialMediaWinners ? nextProps.data.socialMediaSubmissionsReducer.socialMediaWinners : [];
      this.setState({
        socialMediaWinners: socialMediaWinners,
        isLoadingMediaWinners: false,
      });
    }


    if( nextProps.data.socialMediaSubmissionsReducer.socialMediaSubmissionsError !==
      this.props.data.socialMediaSubmissionsReducer. socialMediaSubmissionsError ){
       NotificationManager.error("An error occurred while loading the social media submissions"); 
       this.setState({ isLoading: false });
    } 

    if( nextProps.data.socialMediaSubmissionsReducer.socialMediaSubmissionsError !==
      this.props.data.socialMediaSubmissionsReducer. socialMediaSubmissionsError ){
       NotificationManager.error("An error occurred while loading the social media winners"); 
       this.setState({ isLoadingMediaWinners: false });
    } 
  };

  async componentDidUpdate(prevProps, prevState) {}

  items = [{ title: "Social Media Submission", to: "/social-media-submission" }];

  render() {
       
    const { 
     selectedTab,
     socialMediaWinners,
    } = this.state;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Social Media Submission
                        <small>List of all the social media submission</small>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="m-portlet__body medical-record-content">
                <ul
                    className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                    role="tablist"
                    >
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "Mediafiles",
                        })}                  
                        onClick={() => this.changeTab("Mediafiles") }
                      >
                        Social Media
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: selectedTab === "Winners",
                        })}                  
                         onClick={() => this.changeCustomTimeTab("Winners") }
                      >
                        Social Media Winners
                      </button>
                    </li>       
                  </ul> 

                  <div className="tab-content">
                  {  selectedTab === "Mediafiles" &&
                  <>  
                  {!this.state.isLoading ?
                    <ToolkitProvider
                      keyField="id"
                      data={this.state.socialMediaSubmissions}
                      columns={this.tableHeaderColumnData}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {(props) => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon m--align-right">
                              <i className="fas fa-search mt-1"></i>
                              <SearchBar {...props.searchProps} />
                          </div>
                        </div>
                          <div className="mb-2">
                            <small className="small-text">
                              *If you experience any difficulty in viewing the medical record, please make sure your
                              cache is cleared and completed a hard refresh. IOS users might have to use a private
                              window.
                            </small>
                          </div>
                          <BootstrapTable classes="petTable" {...props.baseProps} pagination={paginationFactory()} />
                        </div>
                      )}
                    </ToolkitProvider>:
                   <div className="center-row" >
                     <Loader size={50} />  
                   </div>
                   } 
                   </>
                   }
                   { selectedTab === "Winners" &&
                   <>
                  {!this.state.isLoadingMediaWinners ?
                    <ToolkitProvider
                      keyField="id"
                      data={socialMediaWinners}
                      columns={this.tableHeaderSocialMediaWinners}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {(props) => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon m--align-right">
                              <i className="fas fa-search mt-1"></i>
                              <SearchBar {...props.searchProps} />
                          </div>
                        </div>
                          <div className="mb-2">                  
                          </div>
                          <BootstrapTable classes="petTable" {...props.baseProps} pagination={paginationFactory()} />
                        </div>
                      )}
                    </ToolkitProvider>:
                   <div className="center-row" >
                     <Loader size={50} />  
                   </div>
                   }
                   </> 
                  }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const Mobile = (props) => <Responsive {...props} maxWidth={767} />;
export const Default = (props) => <Responsive {...props} minWidth={768} />;

const mapStateToProps = (state) => ({
  data: state,
});

const mapDispatchToProps = (dispatch) => ({
  fetchSocialMediaSubmissions: () => {
    dispatch(fetchSocialMediaSubmissions());
  },
  fetchSocialWinners: () => {
    dispatch(fetchSocialWinners());
  }
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);
